// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"content__wrap--3SfMq"};